import { Trophy } from "lucide-react";
import { setterName } from "../lib/leaderboard";

const Badge = ({ testid, label, cls }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1 text-[9px] font-mono font-bold uppercase tracking-widest px-1.5 py-0.5 rounded-sm border ${cls}`}>
    <Trophy className="h-2.5 w-2.5" /> {label}
  </span>
);

export const WinnerBadges = ({ lead, winners }) => {
  const name = setterName(lead);
  const current = winners.current === name;
  const last = winners.last === name;
  if (!current && !last) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {current && <Badge testid={`lead-badge-leader-${lead.id}`} label="Leading this week" cls="bg-amber-400 text-black border-amber-300" />}
      {last && <Badge testid={`lead-badge-last-winner-${lead.id}`} label="Last week's winner" cls="bg-transparent text-amber-300 border-amber-500/60" />}
    </div>
  );
};
